import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable({
   providedIn: 'root'
})
export class mensaService {

    constructor(private http: HttpClient) { }
    getTipiPiatti() {
        return [
            {label:'Antipasto', value: 'Antipasto'},
            {label:'Primo', value: 'Primo'},
            {label:'Secondo', value: 'Secondo'},
            {label:'Dessert Frutta', value: 'Dessert Frutta'},
          ];
    }
}